import { getItem, saveItem } from './genericFB';

export interface TextDesc {
  text: string;
  desc?: string;
}
const COLLECTION_NAME = 'doc-types';

export async function getAccountDocTypes(accountId: string): Promise<TextDesc[] | undefined> {
  const doc = await getItem<{ data: TextDesc[] }>(accountId, COLLECTION_NAME);

  return doc?.data;
}

export async function saveDocTypes(accountId: string, docTypes: TextDesc[]): Promise<TextDesc[] | undefined> {
  const doc = await saveItem<{ data: TextDesc[] }>(accountId, { data: docTypes }, COLLECTION_NAME);

  return doc?.data;
}
